// extracted by mini-css-extract-plugin
module.exports = {"order":"Order_order__21qCL","products":"Order_products__1rIfZ"};